import { useState } from 'react';
import { FaBed, FaCar, FaSearch, FaShip, FaSuitcase } from 'react-icons/fa';
import { PHONE_TEL } from '../../constants/contact';

const TABS = [
  { id: 'hotels', label: 'Hotels', Icon: FaBed },
  { id: 'cars', label: 'Cars', Icon: FaCar },
  { id: 'packages', label: 'Packages', Icon: FaSuitcase },
  { id: 'cruises', label: 'Cruises', Icon: FaShip },
];

const CAR_TYPES = ['Any', 'Economy', 'SUV', 'Luxury', 'Sports'];
const CRUISE_REGIONS = ['Caribbean', 'Mediterranean', 'Alaska', 'Northern Europe'];

export function scrollToTravelSection(sectionId) {
  const el = document.getElementById(sectionId);
  if (el) el.scrollIntoView({ behavior: 'smooth' });
}

export default function CarSearchWidget() {
  const [tab, setTab] = useState('cars');

  const [hotel, setHotel] = useState({
    destination: '',
    checkIn: '',
    checkOut: '',
    adults: '2',
    rooms: '1',
  });

  const [car, setCar] = useState({
    pickup: '',
    dropoff: '',
    pickupDate: '',
    dropoffDate: '',
    carType: 'Any',
  });

  const [pkg, setPkg] = useState({
    destination: '',
    depart: '',
    return: '',
    adults: '2',
  });

  const [cruise, setCruise] = useState({
    port: '',
    region: 'Caribbean',
    depart: '',
    adults: '2',
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    scrollToTravelSection(tab);
  };

  const renderGrid = () => {
    if (tab === 'hotels') {
      return (
        <div className="mcr-search-grid mcr-search-grid--hotels">
          <label className="mcr-search-cell mcr-search-cell--wide">
            <span className="mcr-search-cell__label">Destination</span>
            <input
              type="text"
              value={hotel.destination}
              onChange={(e) => setHotel({ ...hotel, destination: e.target.value })}
              placeholder="Where are you going?"
              required
            />
          </label>
          <label className="mcr-search-cell">
            <span className="mcr-search-cell__label">Check-in</span>
            <input
              type="date"
              value={hotel.checkIn}
              onChange={(e) => setHotel({ ...hotel, checkIn: e.target.value })}
              required
            />
          </label>
          <label className="mcr-search-cell">
            <span className="mcr-search-cell__label">Check-out</span>
            <input
              type="date"
              value={hotel.checkOut}
              min={hotel.checkIn}
              onChange={(e) => setHotel({ ...hotel, checkOut: e.target.value })}
              required
            />
          </label>
          <label className="mcr-search-cell">
            <span className="mcr-search-cell__label">Guests</span>
            <select value={hotel.adults} onChange={(e) => setHotel({ ...hotel, adults: e.target.value })}>
              {[1, 2, 3, 4, 5, 6].map((n) => (
                <option key={n} value={String(n)}>
                  {n} Adult{n > 1 ? 's' : ''}
                </option>
              ))}
            </select>
          </label>
        </div>
      );
    }

    if (tab === 'cars') {
      return (
        <div className="mcr-search-grid mcr-search-grid--cars">
          <label className="mcr-search-cell">
            <span className="mcr-search-cell__label">Pick-up location</span>
            <input
              type="text"
              value={car.pickup}
              onChange={(e) => setCar({ ...car, pickup: e.target.value })}
              placeholder="City or airport"
              required
            />
          </label>
          <label className="mcr-search-cell">
            <span className="mcr-search-cell__label">Drop-off location</span>
            <input
              type="text"
              value={car.dropoff}
              onChange={(e) => setCar({ ...car, dropoff: e.target.value })}
              placeholder="Same or different"
              required
            />
          </label>
          <label className="mcr-search-cell">
            <span className="mcr-search-cell__label">Pick-up date</span>
            <input
              type="date"
              value={car.pickupDate}
              onChange={(e) => setCar({ ...car, pickupDate: e.target.value })}
              required
            />
          </label>
          <label className="mcr-search-cell">
            <span className="mcr-search-cell__label">Drop-off date</span>
            <input
              type="date"
              value={car.dropoffDate}
              min={car.pickupDate}
              onChange={(e) => setCar({ ...car, dropoffDate: e.target.value })}
              required
            />
          </label>
          <label className="mcr-search-cell">
            <span className="mcr-search-cell__label">Car type</span>
            <select value={car.carType} onChange={(e) => setCar({ ...car, carType: e.target.value })}>
              {CAR_TYPES.map((t) => (
                <option key={t} value={t}>
                  {t}
                </option>
              ))}
            </select>
          </label>
        </div>
      );
    }

    if (tab === 'packages') {
      return (
        <div className="mcr-search-grid mcr-search-grid--packages">
          <label className="mcr-search-cell mcr-search-cell--wide">
            <span className="mcr-search-cell__label">Destination</span>
            <input
              type="text"
              value={pkg.destination}
              onChange={(e) => setPkg({ ...pkg, destination: e.target.value })}
              placeholder="Package destination"
              required
            />
          </label>
          <label className="mcr-search-cell">
            <span className="mcr-search-cell__label">Depart</span>
            <input
              type="date"
              value={pkg.depart}
              onChange={(e) => setPkg({ ...pkg, depart: e.target.value })}
              required
            />
          </label>
          <label className="mcr-search-cell">
            <span className="mcr-search-cell__label">Return</span>
            <input
              type="date"
              value={pkg.return}
              min={pkg.depart}
              onChange={(e) => setPkg({ ...pkg, return: e.target.value })}
              required
            />
          </label>
          <label className="mcr-search-cell">
            <span className="mcr-search-cell__label">Travelers</span>
            <select value={pkg.adults} onChange={(e) => setPkg({ ...pkg, adults: e.target.value })}>
              {[1, 2, 3, 4, 5, 6].map((n) => (
                <option key={n} value={String(n)}>
                  {n} Adult{n > 1 ? 's' : ''}
                </option>
              ))}
            </select>
          </label>
        </div>
      );
    }

    return (
      <div className="mcr-search-grid mcr-search-grid--cruises">
        <label className="mcr-search-cell">
          <span className="mcr-search-cell__label">Departure port</span>
          <input
            type="text"
            value={cruise.port}
            onChange={(e) => setCruise({ ...cruise, port: e.target.value })}
            placeholder="Port or city"
            required
          />
        </label>
        <label className="mcr-search-cell">
          <span className="mcr-search-cell__label">Region</span>
          <select value={cruise.region} onChange={(e) => setCruise({ ...cruise, region: e.target.value })}>
            {CRUISE_REGIONS.map((r) => (
              <option key={r} value={r}>
                {r}
              </option>
            ))}
          </select>
        </label>
        <label className="mcr-search-cell">
          <span className="mcr-search-cell__label">Depart</span>
          <input
            type="date"
            value={cruise.depart}
            onChange={(e) => setCruise({ ...cruise, depart: e.target.value })}
            required
          />
        </label>
        <label className="mcr-search-cell">
          <span className="mcr-search-cell__label">Guests</span>
          <select value={cruise.adults} onChange={(e) => setCruise({ ...cruise, adults: e.target.value })}>
            {[1, 2, 3, 4, 5, 6].map((n) => (
              <option key={n} value={String(n)}>
                {n} Adult{n > 1 ? 's' : ''}
              </option>
            ))}
          </select>
        </label>
      </div>
    );
  };

  return (
    <div className="mcr-search-widget">
      <div className="mcr-search-widget__tabs" role="tablist">
        {TABS.map(({ id, label, Icon }) => (
          <button
            key={id}
            type="button"
            role="tab"
            aria-selected={tab === id}
            className={tab === id ? 'active' : ''}
            onClick={() => setTab(id)}
          >
            <Icon aria-hidden /> {label}
          </button>
        ))}
      </div>
      <form className="mcr-search-widget__form" onSubmit={handleSubmit}>
        <div className="mcr-search-row">
          {renderGrid()}
          <button type="submit" className="mcr-search-submit" aria-label="Search">
            <FaSearch size={20} />
          </button>
        </div>
        <p className="mcr-search-widget__note">
          Need help choosing?{' '}
          <a href={`tel:${PHONE_TEL}`}>Call our concierge team 24/7</a>
        </p>
      </form>
    </div>
  );
}
